import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4b212502"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "scheduling-calendar"
}
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 获取排期中... ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_loading = _resolveComponent("van-loading")!
  const _component_van_calendar = _resolveComponent("van-calendar")!

  return (_ctx.showDate )
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_van_calendar, {
          title: "选择日期",
          "show-mark": false,
          formatter: _ctx.formatter,
          show: _ctx.showDate,
          "onUpdate:show": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.showDate) = $event)),
          "default-date": _ctx.defaultDate,
          onConfirm: _ctx.onDateConfirm,
          onSelect: _ctx.onSelectDate,
          type: "single"
        }, {
          footer: _withCtx(() => [
            _createElementVNode("button", {
              class: _normalizeClass(["btn-primary", {'btn-disabled' : !_ctx.schedulingData.length}]),
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onDateConfirm && _ctx.onDateConfirm(...args)))
            }, "确定", 2),
            (_ctx.loading)
              ? (_openBlock(), _createBlock(_component_van_loading, {
                  key: 0,
                  vertical: "",
                  class: "scheduling-calendar-loading"
                }, {
                  default: _withCtx(() => [
                    _hoisted_2
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["formatter", "show", "default-date", "onConfirm", "onSelect"]),
        _createVNode(_Transition, { name: "van-fade" }, {
          default: _withCtx(() => [
            (_ctx.showModal)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showModal=false)),
                  class: "calendar-moadal"
                }, "尊敬的" + _toDisplayString(_ctx.userName) + "先生/女士您好，您预约的体检日期已超规定的保单最长有效期，保单已撤销，您可按预约日期正常参加体检，但需要您重新投保，如有问题，请联系您的营销员协助处理，感谢您的支持与配合！", 1))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]))
    : _createCommentVNode("", true)
}